<template>
    <settings-wrapper title="Space settings" section="Large file storage">
        <the-space-LFS :space-id="activeSpaceId" :is-space-admin-override="isSpaceAdmin" />
    </settings-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import { isAdminRole } from '@/utils'
import SettingsWrapper from '@/components/SettingsWrapper.vue'

const TheSpaceLFS = () => import('../components/TheSpaceLFS.vue')

export default {
    name: 'SpaceConfigurationLfs',
    components: {
        TheSpaceLFS,
        SettingsWrapper
    },
    async created() {
        if (this.activeOrgId && !this.spacesWithPrimarySnapshots.length) {
            await this.$store.dispatch('orgStore/fetchOrgSpaces', this.activeOrgId)
        }
    },
    computed: {
        ...mapState('orgStore', ['spacesWithPrimarySnapshots']),
        activeOrgId() {
            return this.$route.params.oid
        },
        activeSpaceId() {
            return this.$route.params.sid
        },
        activeSpaceData() {
            if (!this.activeSpaceId) {
                return null
            }
            return this.spacesWithPrimarySnapshots.find(space => space.sid.toString() === this.activeSpaceId.toString()) || null
        },
        isSpaceAdmin() {
            return isAdminRole(this.activeSpaceData?.space_role)
        }
    },
    watch: {
        spacesWithPrimarySnapshots: {
            immediate: true,
            handler(spaces) {
                if (!this.$route.params.sid && Array.isArray(spaces) && spaces.length) {
                    this.$router.replace({
                        name: this.$route.name,
                        params: {
                            ...this.$route.params,
                            sid: spaces[0].sid
                        },
                        query: { ...this.$route.query }
                    })
                }
            }
        }
    }
}
</script>
